var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "MobileContainer",
    { class: _vm.$style.accountEditor },
    [
      _c(
        "MobileHeader",
        {
          attrs: {
            slot: "header",
            "disabled-confirm-btn": _vm.profileUpdate,
            "close-to": _vm.redirectIfCancel,
            "show-confirm-btn": !_vm.isNewAccount,
            "nav-action": "back"
          },
          on: { confirmed: _vm.updateUserProfile },
          slot: "header"
        },
        [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]
      ),
      _vm._v(" "),
      _c("CreateAccount", {
        class: _vm.$style.accountEditorForm,
        attrs: { update: _vm.profileUpdate, create: _vm.profileCreate },
        on: {
          "update-complete": _vm.updateUserProfileCompleted,
          "create-complete": _vm.createUserProfileCompleted
        }
      }),
      _vm._v(" "),
      _vm.isNewAccount
        ? _c(
            "MobileButton",
            {
              class: _vm.$style.saveButton,
              attrs: { slot: "footer", disabled: _vm.profileCreate },
              on: { click: _vm.createUserProfile },
              slot: "footer"
            },
            [_vm._v("\n    Save\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "MobileModal",
        {
          attrs: { dialog: "", "center-content": "" },
          model: {
            value: _vm.showProfileCreated,
            callback: function($$v) {
              _vm.showProfileCreated = $$v
            },
            expression: "showProfileCreated"
          }
        },
        [
          _c(
            "MobileConfirmDialog",
            {
              attrs: {
                title: "Account Created",
                "confirm-text": "Let's Go",
                "cancel-disabled": ""
              },
              on: {
                confirm: function($event) {
                  return _vm.goToLogin()
                }
              }
            },
            [_vm._v("\n      Great! Your account has been created.\n    ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.isLoading ? _c("LoadingSpinner") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/mobile/components/MobileUserAccountEditor.vue?vue&type=template&id=576d62c6&
// module id = null
// module chunks = 